import {
  ArrowClockwise,
  ArrowsClockwise,
  CaretDown,
  CaretLeft,
  CaretRight,
  Check,
  FileArrowUp,
  FileMagnifyingGlass,
  FileX,
  Funnel,
  Gear,
  Hammer,
  Megaphone,
  MicrosoftExcelLogo,
  PencilSimple,
  Plus,
  Printer,
  Trash,
  Users,
  X,
} from '@phosphor-icons/react';
import { Translate } from 'next-translate';

export type UniskaiButtonType =
  | 'save'
  | 'cancel'
  | 'refresh'
  | 'delete'
  | 'void'
  | 'add'
  | 'edit'
  | 'filter'
  | 'pivot'
  | 'action'
  | 'export-to-excel'
  | 'complete'
  | 'incomplete'
  | 'submitted-document'
  | 'finished-document'
  | 'close-tour'
  | 'unclose-tour'
  | 'print-invoice'
  | 'clear'
  | 'reset'
  | 'next'
  | 'previous'
  | 'revert-draft'
  | 'resolve-approval'
  | 'request-approval'
  | 'approve'
  | 'reject'
  | 'create-guest'
  | 'order-adjustment'
  | 'revert-void'
  | 'promotion';

export function generateUniskaiActionAsset(
  type: UniskaiButtonType,
  t: Translate,
) {
  switch (type) {
    case 'filter':
      return {
        children: t('common:filter'),
        leftSection: <Funnel size={16} />,
        variant: 'outline',
        color: 'blue',
      };
    case 'save':
      return {
        type: 'submit',
        children: t('common:save'),
        leftSection: <Check size={16} />,
        variant: 'filled',
        color: 'blue',
      };
    case 'cancel':
      return {
        children: t('common:cancel'),
        variant: 'outline',
        color: 'red',
        leftSection: <X size={16} />,
      };
    case 'refresh':
      return {
        children: t('common:refresh'),
        variant: 'outline',
        color: 'blue',
        leftSection: <ArrowsClockwise size={16} />,
      };
    case 'delete':
      return {
        children: t('common:delete'),
        variant: 'outline',
        color: 'red',
        leftSection: <Trash size={16} />,
      };
    case 'add':
      return {
        children: t('common:add'),
        variant: 'filled',
        color: 'blue',
        leftSection: <Plus size={16} />,
      };
    case 'edit':
      return {
        children: t('common:edit'),
        variant: 'outline',
        color: 'blue',
        leftSection: <PencilSimple size={16} />,
      };
    case 'pivot':
      return {
        children: t('common:pivot'),
        variant: 'filled',
        color: 'blue',
        leftSection: <Gear size={16} />,
      };
    case 'action':
      return {
        children: t('common:action'),
        variant: 'outline',
        color: 'blue',
        leftSection: <></>,
        justify: 'space-between',
        rightSection: <CaretDown size={16} />,
      };
    case 'complete':
      return {
        children: t('common:complete'),
        variant: 'filled',
        color: 'blue',
        leftSection: <Check size={16} />,
      };
    case 'export-to-excel':
      return {
        children: t('common:export_to_excel'),
        variant: 'subtle',
        color: 'blue',
        leftSection: <MicrosoftExcelLogo size={16} />,
      };
    case 'incomplete':
      return {
        children: t('common:incomplete'),
        variant: 'outline',
        color: 'red',
        leftSection: <X size={16} />,
      };
    case 'submitted-document':
      return {
        children: t('common:submitted'),
        variant: 'filled',
        color: 'blue',
        leftSection: <Check size={16} />,
      };
    case 'finished-document':
      return {
        children: t('common:finished'),
        variant: 'filled',
        color: 'blue',
        leftSection: <Check size={16} />,
      };
    case 'close-tour':
      return {
        children: t('common:close_tour'),
        variant: 'filled',
        color: 'blue',
        leftSection: <Check size={16} />,
      };
    case 'unclose-tour':
      return {
        children: t('common:unclose_tour'),
        variant: 'outline',
        color: 'red',
        leftSection: <X size={16} />,
      };
    case 'clear':
      return {
        children: t('common:clear'),
        variant: 'outline',
        color: 'red',
        leftSection: <X size={16} />,
      };
    case 'reset':
      return {
        children: t('common:reset'),
        variant: 'subtle',
        color: 'blue',
        leftSection: <ArrowClockwise size={16} />,
      };
    case 'next':
      return {
        children: t('common:next'),
        variant: 'subtle',
        color: 'blue',
        rightSection: <CaretRight size={16} />,
      };
    case 'previous':
      return {
        children: t('common:previous'),
        variant: 'subtle',
        color: 'blue',
        leftSection: <CaretLeft size={16} />,
      };
    case 'promotion':
      return {
        children: t('common:promotion'),
        variant: 'outline',
        color: 'blue',
        leftSection: <Megaphone size={16} />,
      };
    case 'approve':
      return {
        children: t('common:approve'),
        variant: 'filled',
        color: 'blue',
        leftSection: <Check size={16} />,
      };
    case 'reject':
      return {
        children: t('common:reject'),
        variant: 'outline',
        color: 'red',
        leftSection: <X size={16} />,
      };
    case 'create-guest':
      return {
        children: t('common:create_extra', { extra: t('common:guest') }),
        variant: 'outline',
        color: 'blue',
        leftSection: <Users size={16} />,
      };
    case 'request-approval':
      return {
        children: t('common:request_approval'),
        variant: 'filled',
        color: 'blue',
        leftSection: <FileMagnifyingGlass size={16} />,
      };
    case 'revert-draft':
      return {
        children: t('common:revert_draft'),
        variant: 'outline',
        color: 'blue',
        leftSection: <FileX size={16} />,
      };
    case 'resolve-approval':
      return {
        children: t('approval:resolve_approval'),
        variant: 'outline',
        color: 'red',
        leftSection: <Trash size={16} />,
      };
    case 'order-adjustment':
      return {
        children: t('common:order_adjustment'),
        variant: 'filled',
        color: 'blue',
        leftSection: <Hammer size={16} />,
      };
    case 'print-invoice':
      return {
        children: t('common:print'),
        variant: 'subtle',
        color: 'blue',
        leftSection: <Printer size={16} />,
      };

    case 'revert-void':
      return {
        children: t('common:revert_void'),
        variant: 'subtle',
        color: 'blue',
        leftSection: <FileArrowUp size={16} />,
      };
    case 'void':
      return {
        children: t('common:void'),
        variant: 'outline',
        color: 'red',
        leftSection: <Trash size={16} />,
      };
    default:
      return {};
  }
}
